import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDashboardNavContext } from './DashboardNavContext';

const bottomButtonSx = (active, key, { isFirst = false } = {}) => ({
  bgcolor: active === key && '#293143',
  width: '100%',
  height: 40,
  borderRadius: 0,
  borderLeft: !isFirst ? '1px solid #fff' : undefined,
  fontSize: { xs: 10, sm: 12, md: 14 },
});

const headerButtonSx = (active, key) => ({
  color: active === key ? '#95F205' : '#fff',
  textTransform: 'none',
  fontSize: 14,
  fontWeight: active === key ? 700 : 500,
  minWidth: 'auto',
  px: 1.5,
  '&:hover': {
    color: active === key ? '#95F205' : 'rgba(255,255,255,0.85)',
    bgcolor: 'transparent',
  },
});

export default function DashboardNavLinks({ variant = 'bottom' }) {
  const { plan } = useSelector((state) => state.user);
  const { active, toggleVisibleCategory } = useDashboardNavContext();
  const isHeader = variant === 'header';

  return (
    <>
      {plan?.name === 'Pro' ? (
        <Button
          onClick={toggleVisibleCategory}
          variant={isHeader ? 'text' : 'contained'}
          sx={isHeader ? headerButtonSx(active, 'category') : bottomButtonSx(active, 'category', { isFirst: true })}
        >
          Portfolio
        </Button>
      ) : (
        <Button
          component={Link}
          to="/dashboard/main"
          variant={isHeader ? 'text' : 'contained'}
          sx={isHeader ? headerButtonSx(active, 'category') : bottomButtonSx(active, 'category', { isFirst: true })}
        >
          Main
        </Button>
      )}

      <Button
        component={Link}
        to="/dashboard/all-coin"
        variant={isHeader ? 'text' : 'contained'}
        sx={isHeader ? headerButtonSx(active, 'all-coin') : bottomButtonSx(active, 'all-coin')}
      >
        All Coins
      </Button>

      <Button
        component={Link}
        to="/dashboard/assets"
        variant={isHeader ? 'text' : 'contained'}
        sx={isHeader ? headerButtonSx(active, 'assets') : bottomButtonSx(active, 'assets')}
      >
        Assets
      </Button>
    </>
  );
}
